module.exports = __webpack_public_path__ + "2abbd8ee59f37373f9fdf3bebc39cf37.woff";